import { styled, Typography } from '@mui/material'

const ChartTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.leitura.main,
  fontSize: 24
}))

export default ChartTitle
